// packages
const { h, Component } = require("preact");
import { select, scaleLinear } from 'd3';
import { formatNumberPct, formatNumberWithCommas } from '../../utils/utils';
const journalize = require('journalize');

// components

// internal

class ByCategoryBar extends Component {
  constructor() {
    super();

    this.state = {
    }
  }

  drawBar() {
    const container = select(`.bar-container-${this.props.category}`)
    const width = container.node().clientWidth-30;
    const height = 60;
    const rectHeight = 30;
    const margin = {t: 31, l: 0};

    const earlyVote2026 = +this.props.data.early_vote_2026 || 0;
    const totalVotes2026 = +this.props.data.total_votes_2026 || 0;
    const edayVote2026 = totalVotes2026 - earlyVote2026;
    const registered2026 = +this.props.data.registered_2026 || 0;

    // set scales
    const xScale = scaleLinear()
      .domain([0, registered2026])
      .range([margin.l, width]);

    const xPctScale = scaleLinear()
      .domain([0, 100])
      .range([margin.l, width]);

    const svg = container
      .append('svg')
      .attr('width', width)
      .attr('height', height)
    const barsG = svg.append('g')
      .attr('class', 'bars');
    
    
    // people who haven't voted
    barsG.append('rect')
      .attr('class', 'bar-not-voted')
      .attr('x', xScale(totalVotes2026))
      .attr('y', margin.t)
      .attr('width', xScale(registered2026 - totalVotes2026))
      .attr('height', rectHeight)
      .attr('fill', 'lightgray')
      .attr('fill-opacity', 0.7)
      .attr('stroke', 'lightgray')
      .attr('stroke-width', 1.5)

    // people voted on election day
    barsG.append('rect')
      .attr('class', 'bar-total-voted')
      .attr('x', xScale(earlyVote2026) + 1)
      .attr('y', margin.t)
      .attr('width', xScale(edayVote2026))
      .attr('height', rectHeight)
      .attr('fill', '#3fa293')
      .attr('fill-opacity', 0.7)
      .attr('stroke', '#3fa293')
      .attr('stroke-width', 1.5)

    // people voted early
    barsG.append('rect')
      .attr('class', 'bar-voted')
      .attr('x', margin.l)
      .attr('y', margin.t)
      .attr('width', xScale(earlyVote2026))
      .attr('height', rectHeight)
      .attr('fill', '#ffc200')
      .attr('fill-opacity', 0.7)
      .attr('stroke', '#ffc200')
      .attr('stroke-width', 1.5)
    // 2022 early
    const prevEv = barsG.append('g')
      .attr('class', '2022-early')
    prevEv.append('polygon')
      .attr('points', `${xPctScale(+this.props.data.early_vote_2022 / +this.props.data.registered_2022 * 100) - 5} ${margin.t - 7}, ${xPctScale(+this.props.data.early_vote_2022 / +this.props.data.registered_2022 * 100) + 5} ${margin.t - 7}, ${xPctScale(+this.props.data.early_vote_2022 / +this.props.data.registered_2022 * 100)} ${margin.t}`)
      .attr('fill', '#1a2b4b');
    prevEv.append('line')
      .attr('x1', xPctScale(+this.props.data.early_vote_2022 / +this.props.data.registered_2022 * 100))
      .attr('x2', xPctScale(+this.props.data.early_vote_2022 / +this.props.data.registered_2022 * 100))
      .attr('y1', margin.t)
      .attr('y2', margin.t + rectHeight)
      .attr('stroke', '#1a2b4b')
      .attr('stroke-width', 1.5)
      .attr('stroke-dasharray', ('2, 2'));
    if(this.props.category == 'red') {
      const prevEvText = prevEv.append('text')
        .attr('transform', `translate(${xPctScale(+this.props.data.early_vote_2022 / +this.props.data.registered_2022 * 100) + 5}, 10)`)
        .attr('text-anchor', 'end')
        .attr('fill', 'gray')
        .style('font-size', '10px')
      prevEvText.append("tspan")
        .attr('x', 0)
        .attr('dy', 0)
        .text('2022 early')
      prevEvText.append('tspan')
        .attr('x', 0)
        .attr('dy', 10)
        .text('voters (%)')
      const votereg = barsG.append('g')
        .attr('class','votereg-numbers')
      votereg.append('text')
        .attr('x', width-5)
        .attr('dy', 50)
        .attr('text-anchor', 'end')
        .text('100% turnout')
        .attr('fill', 'black')
        .style('font-size', '11px')
    }
    // 2022 total
    const prevTotal = barsG.append('g')
      .attr('class', '2022-total')
    prevTotal.append('polygon')
      .attr('points', `${xPctScale(+this.props.data.total_votes_2022 / +this.props.data.registered_2022 * 100) - 5} ${margin.t - 7}, ${xPctScale(+this.props.data.total_votes_2022 / +this.props.data.registered_2022 * 100) + 5} ${margin.t - 7}, ${xPctScale(+this.props.data.total_votes_2022 / +this.props.data.registered_2022 * 100)} ${margin.t}`)
      .attr('fill', '#348094');
    prevTotal.append('line')
      .attr('x1', xPctScale(+this.props.data.total_votes_2022 / +this.props.data.registered_2022 * 100))
      .attr('x2', xPctScale(+this.props.data.total_votes_2022 / +this.props.data.registered_2022 * 100))
      .attr('y1', margin.t)
      .attr('y2', margin.t + rectHeight)
      .attr('stroke', '#348094')
      .attr('stroke-width', 1.5)
      .attr('stroke-dasharray', ('2, 2'));
    if(this.props.category == "red") {
      const prevTotalText = prevTotal.append('text')
        .attr('transform', `translate(${xPctScale(+this.props.data.total_votes_2022 / +this.props.data.registered_2022 * 100) - 5}, 10)`)
        .attr('fill', '#222222')
        .attr('text-anchor', 'start')
        .style('font-size', '10px')
      prevTotalText.append("tspan")
        .attr('x', 0)
        .attr('dy', 0)
        .text('2022 total')
      prevTotalText.append('tspan')
        .attr('x', 0)
        .attr('dy', 10)
        .text('voters (%)')
    }

    // % voted
    select(`.bar-container-${this.props.category}`)
      .append('div')
      .attr('class', 'text')
      .attr('id',`bar-percentage-${this.props.category}`)
      .attr('style', 'color:#444444')
      .html(`<span class="voted-early-${this.props.category}">${formatNumberPct(earlyVote2026 / registered2026 * 100)}</span> early votes, <span>${formatNumberPct(edayVote2026 / registered2026 * 100)}</span> on election day`)
    // select(`#bar-percentage-${this.props.category}`)
    //   .append('span')
    //   .attr('class', 'text')
    //   .attr('style', 'color:#444444')
    //   .attr('style',`margin-left:${xScale(this.props.data.early_vote_2024)-width(${voted-early-${this.props.category}})}px`)
    //   .html(`<span>${formatNumberPct(+this.props.data.early_vote_2024 / +this.props.data.registered_2024 * 100)}</span>${this.props.data.category == "red" ? " voted early" : ""}`)
    // const annotationsG = barsG.append('g')
    //   .attr('class', 'annotation')
    // annotationsG.append('text')
    //   .attr('class', 'pct_voted')
    //   .attr('x', xScale(+this.props.data.cum_ev_total) + 2)
    //   .attr('y', margin.t + rectHeight - 3)
    //   .text(formatNumberPct(+this.props.data.cum_ev_total / +this.props.data.registered_2024 * 100))
    //   .style('font-weight', 'bold')
    // annotationsG.append('text')
    //   .attr('class', 'cum_ev')
    //   .attr('x', xScale(0) + 2)
    //   .attr('y', margin.t + rectHeight + 12)
    //   .text(`${formatNumberWithCommas(+this.props.data.cum_ev_total)} votes${this.props.data.category == "border" ? " cast so far" : ""}`)
  }

  redrawBar() {
    select(`.bar-container-${this.props.category}`)
      .select('svg')
      .remove()
    select(`.bar-container-${this.props.category}`)
      .select('.text')
      .remove()
    this.drawBar(); 
  }

  componentDidMount() {
    this.drawBar();

    window.addEventListener('resize', () => {
      this.redrawBar();
    })
  }

  render() {   
    return (
      <div class={`bar-cell bar-container-by-category bar-container-${this.props.category}`}>
      </div>
    )
  }
}

export default ByCategoryBar;